"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itIf = exports.describeIf = exports.skipIf = void 0;
function skipIf(f, v) {
    return v ? f : f.skip;
}
exports.skipIf = skipIf;
const describeIf = (v) => skipIf(describe, v);
exports.describeIf = describeIf;
const itIf = (v) => skipIf(it, v);
exports.itIf = itIf;
//# sourceMappingURL=skipIf.js.map